






import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Counter extends Vue {
  selected: boolean = null

  @Prop({ type: Boolean, default: 0 }) initialValue!: boolean
  @Prop({ type: String, default: 'turtoise' }) color: string
  @Prop({ type: Boolean, default: false }) disabled: boolean

  @Watch('initialValue', { immediate: true })
  updateInitial(value) {
    this.selected = value
  }

  @Watch('selected')
  emitSelected(value) {
    this.$emit('change', value)
  }

  classes(value) {
    const classes = []
    classes.push(`is-${this.color}`)

    if (this.selected !== value) {
      classes.push('is-outlined')
    }

    return classes
  }

  updateSelected(value) {
    this.selected = value
  }

  get yesClass() {
    return this.classes(true)
  }

  get noClass() {
    return this.classes(false)
  }
}
